// Add your custom JS here.
jQuery( document ).ready(function() {
    if(jQuery('li.menu-item').length){
        var hash = window.location.hash.substring(1);

        jQuery('li.menu-item').each(function(){
            var menuLink = jQuery(this).find('a').attr('href');
            var type = menuLink.split('#');
            var menuHash = '';
            if(type.length > 1) {
                menuHash = type[1];

                if(menuHash === hash){
                    jQuery(this).addClass('current-menu-item')
                            .addClass('current_page_item')
                            .addClass('active');
                }
            }
        });


        jQuery('li.menu-item a').click(function(){
            var urlhash = window.location.hash.substring(1);

            var menuLink = jQuery(this).attr('href');
            var type = menuLink.split('#');
            var menuHash = '';
            if(type.length > 1) {
                menuHash = type[1];

                jQuery('li.menu-item').each(function(){
                    jQuery(this).removeClass('current-menu-item')
                        .removeClass('current_page_item')
                        .removeClass('active');
                });

                jQuery(this).parent('.menu-item').addClass('current-menu-item')
                    .addClass('current_page_item')
                    .addClass('active');
            }
        });
    }


    if(jQuery('.home-featured-slider').length) {
        jQuery('.home-featured-slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 3000,
            dots: false,
            infinite: true,
            speed: 1500,
            fade: false,
            arrows: true,
            lazyLoad: 'ondemand',
            nextArrow: '<div class="slick-next"><i class="fal fa-chevron-right next"></i></div>',
            prevArrow: '<div class="slick-prev"><i class="fal fa-chevron-left prev"></i></div>'
        })
    }
});